<template>
    <div class="hbrApplicationDesign" id="hbrApplicationDesign">
      <my-header />

      <div class="design pre">
        <div class="wordTitle" id="wordTitle">
          <span>设计自己的产品</span>
        </div>
        <div class="word2">
          在这里您可以任意搭配面板、把手和饰面来设计属于您自己的产品，也可以到我们的产品库里直接选择你喜欢的产品。
        </div>
        <div class="designStyle clear">
          <div class="designTitle">
            <span v-for="(currect, i) in catalogList">
              <a
                href="javascript:void(0)"
                @click="
                  toView(
                    '/applicationTwo?go=wordTitle',
                    'wordTitle',
                    currect.id
                  )
                "
                >{{ currect.name }}</a
              >
              <!-- <router-link to="#">所有</router-link> -->
            </span>
          </div>
          <div class="phoneDesignTitle">
            <span v-for="(currect, i) in catalogList">
              <a
                href="javascript:void(0)"
                @click="
                  toView(
                    '/applicationTwo?go=wordTitle',
                    'wordTitle',
                    currect.id
                  )
                "
                >{{ currect.name }}</a
              >
              <!-- <router-link to="#">所有</router-link> -->
            </span>
          </div>
          <div class="DesignMain clear">
            <div class="designLeft left">
              <div class="designLeftImg"><img :src="detailObj.imgPath1" /></div>
              <div class="designLeftWord" v-html="detailObj.remark"></div>
            </div>
            <div class="designRight left">
              <div class="handle">
                <p class="title">把手</p>
                <div>
                  <b-container>
                    <b-row>
                      <b-col
                        cols="6"
                        xs="6"
                        sm="4"
                        md="4"
                        xl="4"
                        lg="4"
                        v-for="(item, i) in bsPath"
                      >
                        <div>
                          <img :src="item.fileName" />
                          <p class="p1">{{ item.name }}</p>
                        </div>
                      </b-col>
                    </b-row>
                  </b-container>
                </div>
              </div>

              <div class="panel">
                <p class="title">面板</p>
                <div>
                  <b-container>
                    <b-row>
                      <b-col
                        cols="6"
                        xs="6"
                        sm="4"
                        md="4"
                        xl="4"
                        lg="4"
                        v-for="(item, i) in mbPath"
                      >
                        <div>
                          <img :src="item.fileName" />
                          <p class="p1">{{ item.name }}</p>
                        </div>
                      </b-col>
                    </b-row>
                  </b-container>
                </div>
              </div>

              <div class="facing">
                <p class="title">饰面</p>
                <div>
                  <b-container>
                    <b-row>
                      <b-col
                        cols="6"
                        xs="6"
                        sm="4"
                        md="4"
                        xl="4"
                        lg="4"
                        v-for="(item, i) in smPath"
                      >
                        <div>
                          <img :src="item.fileName" />
                          <p class="p1">{{ item.name }}</p>
                        </div>
                      </b-col>
                      <strong></strong>
                    </b-row>
                  </b-container>
                </div>
              </div>
            </div>
          </div>
        </div>
        <my-footer />
      </div>
    </div>
  </template>

  <script>
    import myHeader from "@/views/myHeader.vue";
    import myFooter from "@/views/myFooter.vue";

    export default {
      components: {
        myHeader,
        myFooter
      },
      data() {
        return {
          id: this.$route.query.id,
          detailObj: [],
          bsPath: [],
          mbPath: [],
          smPath: [],
          catalogList: []
        };
      },

      methods: {
        toView(path, goId, id) {
          if (this.$route.fullPath != path) {
            this.$router.push({
              path,
              query: {
                catalogId: id
              }
            });
          } else {
            document.querySelector("#" + goId).scrollIntoView(true);
          }
        },
        showDetail() {
          let that = this;
          that.$axios
            .get(
              that.$global.baseURL + "/web/productDiy/getProductDataById.form",
              {
                params: {
                  id: that.id
                }
              }
            )
            .then(res => {
              if (res.data.jsonArray == "error") {
                uni.showModal({
                  title: res.data.errorInfo,
                  showCancel: false
                });
              } else {
                that.detailObj = res.data.dataList;
                that.bsPath = res.data.bsPathList;
                that.mbPath = res.data.mbPathList;
                that.smPath = res.data.smPathList;
              }
            });
        }
      },
      mounted() {
        this.showDetail();
        if (this.$route.query.go) {
          document
            .querySelector("#" + this.$route.query.go)
            .scrollIntoView(true);
        }
        let that = this;
        that.$axios
          .get(
            that.$global.baseURL + "/web/productDiyCatalog/getCatalogData.form"
          )
          .then(res => {
            if (res.data.jsonArray == "error") {
              uni.showModal({
                title: res.data.errorInfo,
                showCancel: false
              });
            } else {
              that.catalogList = res.data.dataList;
            }
          });
      }
    };
  </script>

  <style>
    .hbrApplicationDesign {
      width: 100%;
    }

    .hbrApplicationDesign .pre .wordTitle {
      width: 90%;
      text-align: center;
      margin: 0 auto;
      color: #595757;
      font-size: 45px;
      padding-top: 45px;
      letter-spacing: 10px;
      font-weight: lighter;
    }

    .hbrApplicationDesign .pre .word2 {
      width: 88%;
      margin: 0 auto;
      text-align: center;
      margin-top: 20px;
      margin-bottom: 40px;
      font-size: 14px;
      line-height: 30px;
      letter-spacing: 1px;
      color: #595757;
    }

    .hbrApplicationDesign .designStyle {
      border-top: 1px solid #c4c4c4;
      background-color: white;
      margin: 0 auto;
      margin-top: 50px;
      padding-bottom: 120px;
    }

    .designStyle .designTitle {
      width: 70%;
      margin: 0 auto;
      text-align: center;
      font-size: 16px;
      padding-top: 50px;
    }

    .designStyle .designTitle span {
      letter-spacing: 2px;
      margin: 0 auto;
      padding: 0px 45px;
    }

    .designStyle .designTitle a {
      text-decoration: none;
      color: #595757;
    }

    .designStyle .designTitle a:hover {
      text-decoration: none;
      color: #ccb356;
    }

    .designStyle .DesignMain {
      width: 90%;
      margin: 0 auto;
      margin-top: 75px;
    }

    .designStyle .DesignMain .designLeft {
      width: 50%;
      margin-left: -15px;
      /* 
		border: 1px solid red; */
    }

    .designStyle .DesignMain .designLeft .designLeftImg {
      width: 90%;
      margin: 0 auto;
    }

    .designStyle .DesignMain .designLeft .designLeftImg img {
      width: 90%;
      text-align: center;
    }

    .designStyle .DesignMain .designLeft .designLeftWord {
      width: 90%;
      margin: 0 auto;
    }

    .designStyle .DesignMain .designLeft .designLeftWord p {
      width: 85%;
      font-size: 14px;
      margin-top: 30px;
      line-height: 25px;
      letter-spacing: 1px;
      color: #595757;
    }

    .designStyle .DesignMain .designRight {
      width: 50%;
      /* margin-left: -20px; */
      /* border: 1px solid red; */
      color: #595757;
    }

    .designStyle .DesignMain .designRight .title {
      padding-top: 10px;
      font-size: 18px;
      border-top: 1px solid #c4c4c4;
    }

    .designStyle .DesignMain .designRight .p1 {
      font-size: 12px;
      margin-top: 20px;
    }

    .designStyle .DesignMain .designRight img {
      width: 80%;
      margin-top: 30px;
    }

    .phoneDesignTitle {
      display: none;
    }

    @media screen and (max-width: 576px) {
      .designTitle {
        display: none;
      }

      .phoneDesignTitle {
        width: 100%;
        text-align: center;
        display: block;
        margin-top: 15px;
      }

      .phoneDesignTitle span {
        padding: 20px 16px;
        position: relative;
        top: 33px;
      }

      .phoneDesignTitle span a {
        color: #595757;
      }

      .phoneDesignTitle span a:hover {
        color: #ccb356;
        text-decoration: none;
      }

      .designStyle .DesignMain .designLeft {
        margin-left: 20px;
        margin-bottom: 20px;
        width: 100%;
      }

      .designStyle .DesignMain .designRight {
        width: 100%;
      }

      .footer {
        margin-top: -10px;
      }
    }
  </style>
</template>
